import * as React from 'react';

export const ExpandIcon = (props: React.ComponentProps<'svg'>) => {
	return (
		<svg height={14} width={14} viewBox='0 0 14 14' {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.875 1.75H11.0127L1.75 11.0127V7.875H0V14H6.125V12.25H2.98725L12.25 2.98725V6.125H14V0H7.875V1.75Z'
				fill='currentColor'
			/>
		</svg>
	);
};
